module.exports = __webpack_public_path__ + "7a6bc10028a79f78e424a9c71499fa77.jpg";